
import React, { useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import TypingText from './TypingText';
import SEO from '../SEO';
import Header from './Header';
import Footer from './Footer';

const RefundPolicy = () => {

  const [showContactInfo, setShowContactInfo] = useState();
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  const hasRun = useRef(false);


  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const media = window.matchMedia("(width <= 1024px)");

    function updateNavbar(e) {
      const isMobile = e.matches;
      const menu_div = document.getElementById("mob_menu");
      if (isMobile) {
        menu_div.style.display = "block";
        navbar.setAttribute("inert", "");
      } else {
        menu_div.style.display = "none";
        navbar.removeAttribute("inert");
      }
    }

    media.addEventListener("change", updateNavbar);
    updateNavbar(media);

    return () => media.removeEventListener("change", updateNavbar);
  }, []);




  const openSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");


    navbar.classList.add("show");
    openButton.setAttribute("aria-expanded", "true");
    openButton.style.display = "none";
    navbar.removeAttribute("inert");
  };

  const closeSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");

    if (openButton.getAttribute('aria-expanded') === 'true') {


      navbar.classList.remove('show');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.setAttribute('style', 'display: block;');
      navbar.setAttribute('inert', '');

    }
  };


  return (

    <div className='w-screen h-full'>

      <Header></Header>
    

      <div id="overlay" aria-hidden="true"></div>

      <div className="tchead">
        <div className="tcinhead">
          <div style={{ textAlign: "center" }}>
            <h1>
            <b>
              Refund Policy
              Effective Date: June 2, 2025</b>
              </h1>
              <br /><br />
          </div>
          At AlgoController.com, customer satisfaction is our top priority. We strive to deliver reliable and timely alerts for all our users. However, we understand there may be rare instances where an alert is not received as expected.
          <br />
          Our refund policy is as follows:
          <br /><br />
          <b>1. Full Refund – No Questions Asked</b><br />
          &nbsp;&nbsp;&nbsp; * If you notify us within 5 days of the payment deduction and confirm that no alert was received, you will receive a 100% refund, with no deductions or charges.
          <br /><br />
          <b>2. Partial Refund – 60%</b><br />

          &nbsp;&nbsp;&nbsp; * If you notify us between the 6th and 10th day after the payment deduction, you will be eligible for a 60% refund of the deducted amount.
          <br />
          <br />
          <b>3. Partial Refund – 50%</b><br />
          &nbsp;&nbsp;&nbsp; * If you notify us between the 11th and 15th day, we will refund 50% of the deducted amount.
          <br /><br />
          <b>4. No Refund</b><br />
          &nbsp;&nbsp;&nbsp; * If the issue is reported after 20 days, we will not be able to process any refund.<br />
          <br />
          <b>Important Notes:</b><br />

          &nbsp;&nbsp;&nbsp; * Refunds are only applicable in cases where no alert was received as per our system logs.
          <br />
          &nbsp;&nbsp;&nbsp; * Please ensure that your notification is sent via email or our official support system within the appropriate time frame.
          <br />
          &nbsp;&nbsp;&nbsp; * Refunds, once approved, will be processed within 5-7 business days.
          <br /><br />
          <b>5. Contact Information</b><br />
          &nbsp;&nbsp;&nbsp; * If you have any questions or need clarification, reach out to us at:
          <b>
            📧 Email: support@algocontroller.com</b>
          <br /><br />
        </div>
      </div>

      <br></br>



      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" >&times;</span>
          <h2>Hello!</h2>
          <p><b>We’re working hard behind the scenes to bring something great!</b><br />
            Some features and links will be available soon.<br />
            Thank you for your patience — our website is currently under construction.</p>
        </div>
      </div>

      <br /><br />
    <Footer></Footer>

    </div>

  )
}

export default RefundPolicy